import {useI18nContext} from "../../../../contexts/I18nContext";
import {useStyles} from './ElementRow.style';
import React from "react";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ElementRowProperties from "./ElementRowProperties";
import clsx from "clsx";

const SalePriceElementRow: React.FC<ElementRowProperties> = ({
                                                               element,
                                                               onSelect,
                                                               className,
                                                               selected
                                                           }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    
    return (
        <div className={clsx(classes.element_row_container, className, selected && classes.active)}
             onClick={() => onSelect(element)}>
            <div className={classes.icon_info}>
                <RequestQuoteIcon/>
            </div>

            <div className={classes.text_container}>
                <div><b>{element.name}</b></div>
                <div><b>{i18n.translate("DESCRIPTION")}:</b>{`${element.name}`}</div>
            </div>

        </div>
    )
}


export default SalePriceElementRow;